module.exports = __webpack_public_path__ + "static/media/test2.bcb29cf7.png";